import { API_URL } from '~/constants/environment'

import { Api } from '../../utils/api'
import type { ApiSession } from '../@types'

const api = new Api(API_URL, 'customers/sessions')

export const createSession = async (app_id: string) => {
  return (
    await api.post<{ data: ApiSession }>({
      body: {
        data: {
          type: 'customer_session',
          attributes: {
            app_id,
          },
        },
      },
    })
  ).data
}
